<template>
  <div class="userinfo" id="userInfoDiv">

    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="previewUrl" alt />
    </el-dialog>


    <!--企业信息编辑-->
    <el-dialog
        :visible.sync="redactVerify"
        class="redact-dialog">
        <div class="redact-div">
          <div class="redact-title">企业信息修改</div>
          <hr>
          <div class="redact-centre">
            <el-form :model="userInfos" :rules="mesVerification" ref="redactMes" label-width="100px" class="demo-ruleForm">
                <el-form-item  :label="language.guestscompanyName + ':'" prop="company">
                  <el-input type="text" v-model="userInfos.company" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  :label="language.companyProperty + ':'" prop="nature">
                  <el-select
                      v-model="userInfos.nature">
                    <el-option
                        v-for="item in firmQuality"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  :label="language.home + ':'" style="position: relative;" prop="location">
                  <el-input type="text" v-model="userInfos.location" v-on:click.native="showArea" :readonly="true" autocomplete="off"></el-input>
                  <i :class="!areaVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="position: absolute;right: 80px;top: 11px;color: #C0C4CC"></i>
                </el-form-item>
                <el-form-item  :label="language.email3 + ':'" prop="email">
                  <el-input type="text" v-model="userInfos.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  :label="language.creditCode + ':'" prop="credit_code">

                  <el-input type="text" v-model="userInfos.credit_code"  :readonly="userInfos.check_status==1" autocomplete="off"></el-input>
                  <div style="font-size: 14px;color: #ff0000;margin-left: 60px;">审核完成后无法再次修改</div>
                </el-form-item>
                <el-form-item  :label="language.businessLicense + ':'" prop="business_license">
                  <el-upload
                      :action="fileUpload"
                      class="uploadImg"
                      list-type="picture-card"
                      :on-success="updateSuccessBL"
                      :before-upload="onBeforeUpload"
                      :on-remove="handleRemoveBL"
                      :on-preview="handlePictureCardPreview"
                      :limit="1"
                      v-model="this.userInfos.business_license"
                      :file-list="imgList2"
                      accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
                  >
                  <i slot="default" class="el-icon-plus" style="font-size: 40px;position: relative;top:-20px;"></i>
                  </el-upload>
                  <div
                      style="font-size:14px;color:#808080;width: 130px;color: #777777;
                             position: absolute;left: 160px;top: 40px;margin: 0;padding: 0;"
                    ><div style="height: 20px">{{language.suggestSize1}}</div>
                    <div style="height: 30px">{{language.suggestSize4}}</div>
                  </div>
                </el-form-item>
                <el-form-item  :label="language.contactPeople + language.username + ':'" prop="true_name">
                  <el-input type="text" v-model="userInfos.true_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  :label="language.contactPeople + language.userPost + ':'" prop="user_post">
                  <el-input type="text" v-model="userInfos.user_post" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  :label="language.Introduction + ':'" prop="company_desc">
                <el-input type="textarea" v-model="userInfos.company_desc"
                          autocomplete="off" style="border-radius: 5px;"
                          rows = "4" :placeholder="language.IntroductionCom"></el-input>
                </el-form-item>
                <el-form-item  :label="language.Logo + ':'" prop="company_logo_url">
                  <el-upload
                      :action="fileUpload"
                      class="uploadImg"
                      list-type="picture-card"
                      :on-success="updateSuccess"
                      :before-upload="onBeforeUpload"
                      :on-remove="handleRemove"
                      :on-preview="handlePictureCardPreview"
                      :limit="1"
                      v-model="userInfos.company_logo_url"
                      :file-list="imgList"
                      accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
                  >
                  <i slot="default" class="el-icon-plus" style="font-size: 40px;position: relative;top:-20px;"></i>
                </el-upload>
                  <div
                      style="font-size:14px;color:#808080;width: 130px;color: #777777;
                             position: absolute;left: 160px;top: 40px;margin: 0;padding: 0;"
                  ><div style="height: 20px">{{language.suggestSize1}}</div>
                    <div style="height: 30px">{{language.suggestSize3}}</div>
                  </div>
                  <!-- <div class="deleteResume" @click="deleteFile('company_logo_url')">
                    <span style="color: #FFFFFF;font-weight: normal;
                                  font-size: 18px;cursor: pointer;
                                  position: relative;top: 25px;"
                    >删除</span>
                  </div> -->
                </el-form-item>
              <el-form-item class="btn">
                <el-button type="warning"
                           style="width: 161px;height: 56px;border-radius: 4px;font-size: 24px; background-color: #f47900;margin-top: 20px;letter-spacing: 5px"
                            @click="ok">提交</el-button>
                <el-button type="info" style="width: 161px;height: 56px;border-radius: 4px;font-size: 24px;background-color: #d9d9d9;color: #333333;border: none;margin-left: 40px;letter-spacing: 5px" @click="redactVerify=false">取消</el-button>
              </el-form-item>
            </el-form>

          </div>
        </div>
    </el-dialog>
    <area-div v-model="areaName" :areaEl="areaEl" :visible.sync="areaVisible" @areaVisibleEvent="areaVisibleEvent" parentId="userInfoDiv"/>
  </div>
</template>
<script>
import reqest from "@/common/reqest";
import {getLanguage, language} from "../../../language/get";
import {getUserInfo, updateUserInfo, getUserBalance, updateTel} from "../../../api/user";
import store from "../../../store";
import Cookie from "../../../common/cookie"
import receiveMsg from '../../../components/receiveMsg'
import {selectEducation } from "../../../api/exhibition";
import areaDiv from "@/components/area/index";
import {mapGetters} from "vuex";
import {goCloudPay} from "@/api/order";
import {retPwdNum} from "@/api/login";
import {isEmail} from "@/common/validate";


export default {
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  data() {
    let Lan = getLanguage('ch');
    return {
      changePhone:{
        user:"",
        code:""
      },
      defaultImg: 'this.src="' + require('@/assets/ic_enclosure.png') + '"',
      experienceList:['应届毕业生','1年以下','1-2年','2-3年','3-4年','4-5年','5年以上'],
      areaVisible: false,
      areaName: '',
      areaEl: null,
      perfectMess: false,
      educationList:null, // 最高学历列表
      showImage:null, //上传简历后显示的图片
      ruleForm: {
        name: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入活动名称', trigger: 'blur'},
          {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ]
      },
      accountRules: {
        user: [
          { required: true, message: language().phoneRules, trigger: "blur" },
        ],
        code: [{ required: true,validator: this.checkLoginCode, trigger: "blur" }]
      },
      //企业性质
      firmQuality:[
        {
          value:'0',
          label:getLanguage().companyProperty1
        },{
          value:'1',
          label:getLanguage().companyProperty2
        },{
          value:'2',
          label:getLanguage().companyProperty3
        },{
          value:'3',
          label:getLanguage().companyProperty4
        },{
          value:'4',
          label:getLanguage().companyProperty5
        },{
          value:'5',
          label:getLanguage().companyProperty6
        }],

      fileUpload: reqest.apiUrl+'/Home/Publicother/uplodadLogo',
      language: language(),
      user_balance: 0,
      userInfos: {
        name:"",
        check_status: '',
      },
      imgList: [],
      imgList2: [],
      imgList3: [],
      fileList:[],
      previewUrl: '',
      dialogVisible: false,
      lan: Cookie.get("lang"),
      hiddenMes: '1',
      chanceTel: false,
      chanceTelCom:false,
      redactVerify: false,
      codeFlag:0,
      btnFindName: language().sendVerificationCode,
      finTimer: null,
      gender:[{
        value:2,
        label:language().woman
      },{
        value: 1,
        label:language().man
      }],
      gender1:"",
      educationHest:"",
      //token:this.userInfos.token
      mesVerification:{
        company: [
          {
            required: true,
            message: language().companyNameRules,
            trigger: "blur",
            max: 100
          }
        ],
        nature: [{ required: true, message: language().propertyRules, trigger: "blur" }],
        email: [{ required: true, validator: this.emailValidator, trigger: "blur" }],
        location:[
          {
            required:true,
            message:"请输入所在城市",
            trigger:"blur"
          }
        ],
        credit_code:[
          {
            required:true,
            message:"请输入统一社会信用代码",
            trigger:"blur"
          }
        ],
        user_post: [
          { required: true, message: language().jobRules, trigger: "blur", max: 60 }
        ],
        true_name: [
          {
            required: true,
            message: language().trueNameRules,
            trigger: "blur",
            max: 50
          }
        ],
        tel:[
          {
            required:true,
            message:"请输入手机号",
            trigger:"blur"
          }
        ],
        company_desc:[
          {
        required:true,
        message:"请输入公司简介",
        trigger:"blur"
          }
        ],
        company_logo_url:[
          {
            required:true,
            message:"请选择logo",
            trigger:"blur"
          }
        ],
        business_license:[
          {
            required:true,
            message:"请选择营业执照",
            trigger:"blur"
          }
        ],
      }
    };
  },
  components:{
    receiveMsg,
    areaDiv
  },
  created() {
    //this.userInfo();

    /*this.userInfos = this.$store.state.user.userInfo
    if(this.userInfos.company_logo_url){
      this.imgList = [{ status: "success", url: this.userInfos.company_logo_url }];
    }else{
      this.imgList = [];
    }*/
  },
  mounted() {
    this.userInfot();
    //this.getUserBalanceInfo();
    selectEducation().then((res) =>{
          if(res.type == 1){
            const data = res.data;
            this.educationList = data;
            console.log("1", this.educationList);
          }
    });
    },
  methods: {
    emailValidator(rule, value, callback){
      // if(this.userInfo.register_area == 2){
      isEmail(rule, value, callback);
      // }else{
      //   callback();
      // }
    },
    //点击获取验证码
    getCode() {
      let promise = [];
      this.codeFlag = 1;
      // console.log("this.codeFlag= " + this.codeFlag);
      promise.push(this.$refs.newTel.validate());
      Promise.all(promise).then(() => {
        //请求
        let timeCount = 60;
        if (!this.finTimer) {
          this.btnFindName = timeCount + "s";
          retPwdNum({ tel: this.changePhone.user }).then((res) => {
            if (res.type != 1) {
              if (this.lan == "ch") {
                const height = document.body.clientHeight / 2;
                this.$message.error({ message: res.text, offset: height });
              } else {
                return this.$message.error({
                  message: res.text_en,
                  offset: 240,
                });
              }
            }
          });
          this.finTimer = setInterval(() => {
            if (timeCount === 0) {
              this.btnFindName = this.language.toResend;
              clearInterval(this.finTimer);
              this.finTimer = null;
            } else {
              timeCount--;
              this.btnFindName = timeCount + "s";
            }
          }, 1000);
        }
      });

    },
    //提交
    submit() {
      let promise = [];
      console.log("新手机号： " + this.changePhone.user + " " +this.changePhone.code + " " + this.userInfo.user_id);
      let data = {
        user_id:this.userInfo.user_id,
        tel:this.changePhone.user,
        code:this.changePhone.code
      };
      promise.push(this.$refs.newTel.validate());
      Promise.all(promise).then(() => {
        updateTel(data).then((res) => {
          const height = document.body.clientHeight / 2;
          if(res.type != 1) {
            this.$message.error({ message: res.text, offset: height });
          }else {
            this.$message.success({ message: res.text, offset: height });
            this.chanceTelCom = false;
          }

        });
      });

    },
    //取消
    cancel() {
      this.chanceTelCom = false;
    },
    //验证码 验证
    checkLoginCode(rule, value, callback){
      if (!value && this.codeFlag == 0) {
        console.log("value=" + value);
        callback(new Error(language().codeRules));
      }
      callback();
    },
    showResume(){
      if(this.userInfos.resume_file){
        // window.open(this.userInfos.resume_file);
        window.location.href = "user.html#/onlineResume"
      }else{
        const height = document.body.clientHeight / 2;
        this.$message({
          showClose: true,
          message: "你还没有上传简历",
          type: "error",
          offset: height
        });
      }

    },
    areaVisibleEvent(visible){
      this.areaVisible = visible;
      this.userInfos.location = this.areaName;
    },
    showArea(e){
      this.areaName = this.userInfos.location;
      this.areaEl = e.target;
      this.areaVisible = true;
    },
    deleteFile(key){
      if(key == 'resume_file'){
        this.imgList3 = [];
        this.userInfos.resume_file = '';
      } else if(key == 'company_logo_url'){
        this.imgList = [];
        this.userInfos.company_logo_url = '';
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: '',
        key: Date.now()
      });
    },
    yunqian() {
      let porp = {
        user_id:this.userInfos.user_id
      }
      goCloudPay(porp).then((res)=> {
          let url = res.data;
          // console.log("22222444" , res.data);
          window.open(url);
      });
    },
    goRecharge(){
      window.location.href = "rechargePage.html"
    },
    handlePictureCardPreview(file) {
      let url = file.url;
      if(url.indexOf('.pdf') > -1){
        window.open(file.url);
      }else{
        this.previewUrl = file.url;
        this.dialogVisible = true;
      }

    },
    handleRemove() {
      this.userInfos.company_logo_url = "";
    },
    handleRemoveJL() {
      this.userInfos.resume_file = "";
      this.$refs.jlFileUpload.clearFiles();
    },
    handleRemoveBL() {
      this.userInfos.business_license = "";
    },
    onBeforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 20;
      const height = document.body.clientHeight / 2;
      if (!isLt1M) {
        this.$message({
          showClose: true,
          message: this.language.fileMaxSize,
          type: "error",
          offset: height
        });
      }

      return isLt1M;
    },
    chancePhoneBtn() {
      this.chanceTel = true;
    },
    change() {
      this.btnFindName = "获取验证码";
      clearInterval(this.finTimer);
      this.finTimer = null;
      this.changePhone.code = "";
      this.changePhone.user = "";
      this.chanceTelCom = true;
    },
    updateSuccess(res) {
      if (res.type == "1") {
        this.userInfos.company_logo_url = res.data.file.picurl;
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    updateSuccessBL(res) {
      if (res.type == "1") {
        this.userInfos.business_license = res.data.file.picurl;
        console.log("88888:" + res.data.file.picurl);
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    updateSuccessJL(res) {
      if (res.type == "1") {
        this.userInfos.resume_file = res.data.file.picurl;
        console.log("88888:" + res.data.file.picurl);
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    userInfot() {
      let data = {
        token: this.$store.state.user.token
      };
      getUserInfo().then(res => {
        if (res.type != '1') {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
          this.userInfos = res.data[0];
          // console.log("222222222222" , this.userInfos);
          if(this.userInfos.company_logo_url){
            this.imgList = [{ status: "success", url: this.userInfos.company_logo_url }];
          }else{
            this.imgList = [];
          }
          if(this.userInfos.business_license){
            this.imgList2 = [{ status: "success", url: this.userInfos.business_license }];
          }else{
            this.imgList2 = [];
          }
          if(this.userInfos.resume_file){
            this.imgList3 = [{ status: "success", url: this.userInfos.resume_file }];
          }else{
            this.imgList3 = [];
          }
          if(this.userInfos.company == null || this.userInfos.location == null || this.userInfos.credit_code == null ||
            this.userInfos.business_license == null || this.userInfos.true_name == null || this.userInfos.user_post == null ||
            this.userInfos.tel == null || this.userInfos.company_desc == null || this.userInfos.company_logo_url == null ||
            this.userInfos.company == "" || this.userInfos.location == "" || this.userInfos.credit_code == "" ||
            this.userInfos.business_license == "" || this.userInfos.true_name == "" || this.userInfos.user_post == "" ||
            this.userInfos.tel == "" || this.userInfos.company_desc == "" || this.userInfos.company_logo_url == ""){
          this.perfectMess = true;
        }
          for (var i = 0; i < this.gender.length; i++) {
            if(this.gender[i].value == this.userInfos.sex){
              this.gender1 = this.gender[i].label;
              break;
            }
          }

          // for(var index in this.educationList){
          //   if(index.value == this.userInfos.edcation_id) {
          //
          //   }
          // }
          // this.educationHest = this.educationList[this.userInfos.education_id];
          // console.log("233333==" + this.userInfos.user_nature);

      });
    },
    getUserBalanceInfo() {
      let data = {
        user_id: this.$store.state.user.userInfo.user_id
      };
      getUserBalance(data).then(res => {
        if (res.type != '1') {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
        this.user_balance = res.data;

      });
    },
    //企业信息  去编辑
    redactPop() {
        this.redactVerify = true;
    },
    //确认修改
    ok() {
        this.editUserInfo();
    },
    editUserInfo(){
      let promise = [];
      let data = {
        lan: this.lan,
        token:this.$store.state.user.token,
        company: this.userInfos.company,
        location: this.userInfos.location,
        true_name: this.userInfos.true_name,
        user_post: this.userInfos.user_post,
        tel_phone: this.userInfos.tel_phone,
        company_desc: this.userInfos.company_desc,
        credit_code: this.userInfos.credit_code,
        age: this.userInfos.age,
        sex: this.userInfos.sex,
        education_id: this.userInfos.education_id,
        resume_file: this.userInfos.resume_file,
        email: this.userInfos.email,
        start_job_date: this.userInfos.start_job_date,
        resume_show: this.userInfos.resume_show,
        school: this.userInfos.school,
        company_logo_url: this.userInfos.company_logo_url,
        person_resume_url:this.userInfos.person_resume_url,   //简历路径
        business_license:this.userInfos.business_license,  //营业执照路径
        nature: this.userInfos.nature
      };
      //console.log("营业执照：" + this.userInfos.business_license);
      //console.log("logo：" + this.userInfos.company_logo_url);
      if(this.userInfos.user_nature == '1'){
        this.updateUserInfoFun(data);
      }else{
        promise.push(this.$refs.redactMes.validate((valid) => {
          if(!valid){
            console.log("信息填写不完全！");
            return false;
          }
          this.updateUserInfoFun(data);

        }));
      }


    },
    updateUserInfoFun(data){
      updateUserInfo(data, this).then(res => {
        const height = document.body.clientHeight / 2;
        if(res.type == 1) {
          this.$message({
            showClose: true,
            message: this.lan == 'ch' ? res.text : res.text_en,
            type: "success",
            offset: height
          });
          this.redactVerify = false;
        }else {
          this.$message({
            showClose: false,
            message: this.lan == 'ch' ? res.text : res.text_en,
            type: "error",
            offset: height
          });
          this.redactVerify = true;
        }

          let dd = this.userInfos;
          for(let d in data){
             this.userInfos[d] = data[d];
          }
          this.$store.commit("SET_USERINFO", this.userInfos);
          this.$emit("userSaveEvent",this.userInfos);
        this.$emit("editSave",true,this.userInfos);
           //this.$store.commit("SET_USERINFO", userDet);
        /*if (res.type == "1") {
          this.$message({
            showClose: true,
            message: this.language.editSuccess,
            type: "success",
            offset: "100"
          });
          this.$refs.dialogChild.receiveDialogFormVisible = false;
          this.onClear();
        } else {
          return this.$message.error({ message: res.text, offset: 120 });
        }*/
      })
      .catch(() => {});
    },
   //下载谷歌浏览器
     download() {
       window.open("https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds")
      }
  },

};
</script>
<style scoped>
.xiugai {
  clear: both;
  width: 500px;
  text-align: left;

}
.new-tel >>> .el-input__inner {
  width: 390px;
  background-color: #f5f6f7;
  border-radius: 5px;
  border: solid 1px #d9d9d9;
}
.code-name >>>  .el-input__inner {
  width: 270px;
  background-color: #f5f6f7;
  border-radius: 5px;
  border: solid 1px #d9d9d9;
}
.xiugai span {
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  text-align: right;
}
.xiugai {
  clear: both;
}
.xiugai >>> .el-form-item__error {
  position: relative;
  left: 85px;
  top: 5px;
}
.userinfo .userinfoList {
  border: none;
  /*height: 1166px;*/
  /*background: #ffffff;*/
  /*padding:30px 49px 40px 49px;*/
  /* padding-left: 150px !important; */
  box-sizing: border-box;
}
.userinfo-top{
  background: url('../../../assets/img/38.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 20px 0px 10px 40px;
  margin-bottom: 20px;
}
.top-div{
  min-width: 260px;
  /*border: 1px solid #fff;*/
  display: inline-block;
  padding: 5px 10px 5px 30px;
  border-radius: 10px;
  font-size: 22px;
  /* color: #fff !important; */
}
.itemRow-new{
  margin-bottom: 10px;
}
.userinfo .itemRow {
  margin-bottom: 20px;
}
.w-107 {
  width: 220px;
  color: #424242;
  font-size: 16px;
  display: inline-block;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  text-align: right;
  padding-right: 10px;
}
.w-top-107-new{
  width: 150px;
  color: #fff;
  font-size: 22px;
  display: inline-block;
}
.w-top-107 {
  width: 150px;
  color: #424242;
  font-size: 16px;
  display: inline-block;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
  .l-text-gray {
    color: #a1a1a1;
    font-size: 16px;
  }
.l-text-gray >>> .el-form-item__label{
  /* font-size: 16px !important;*/
  width: 220px !important;
  /*margin-right: 40px !important;*/
  height: 16px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
 }
.l-text-gray >>> .el-form-item__error{
  margin-left: 120px;
  margin-top: 2px;
  font-size: 14px;
}
  .l-text-gray >>> .el-input__inner{
    /*color: #56575a !important;*/
    /*background-color: #f4f5f6;*/
    /*width: 397px;*/
    height: 39px;
    background-color: #f5f6f7;
    border-radius: 5px;
    border: solid 1px #d9d9d9;
  }

  .l-text-gray >>> .el-textarea__inner{
    color: #56575a !important;
    background: #f4f5f6;
  }
  .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 60%;
}
.el-col-12{
  width: 90%;
}
.saveBtn{
  margin-left:300px;
  width: 150px;
}
.prompt-info-box{
  background:#fff;
  height:30px;
  padding:15px;
  width:960px;
  margin-left:200px;
}
.prompt-info-wrap{
  width: 940px;
  padding: 10px 0 5px 50px;
  background: #fcf6f2;
  margin-bottom: 30px;
  border-radius: 5px;
}
.prompt-info{
  height:30px;
  /* line-height:30px; */
  background:#fcf6f2;
  padding-left:15px;
  color:#ed6c00;
  font-size:16px;
  font-weight:bold;
  padding: 5px 10px;
  /* border:1px solid #f6dcc8; */
}

.prompt-info span{
  color:#0f408a;
  cursor:pointer;
}
.userinfo >>> .el-textarea{
  width: 60% !important;
  font-size: inherit !important;
  vertical-align: top;
  margin-top: -2px;
}
</style>
<style>
.itemRow .el-upload{
   background: #F2F2F2;
   border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

}
.itemRow .el-upload .upText{
  font-size: 14px;
  color: #424242;
  line-height: normal;
}
.itemRow .uploadImg {
  display: flex;
  width: 160px;
  margin-left: 120px;
}
.itemRow .uploadImg .el-upload-list
.uploadResume .el-upload-list{
  margin-right: 20px;
  position: absolute;
  z-index: 999;
}
.uploadResume {
  display: flex;
}
/*.itemRow .uploadResume .el-upload--picture-card {
  width: 120px !important;
  height: 120px !important;
}*/
.deleteResume {
  width: 120px;
  height: 120px;
  position: absolute;
  left: 400px;
  top:0px;
  border-radius: 5px;
  background: url("../../../assets/img/21.png") no-repeat;
  background-size: 120px 120px;
  text-align: center;
  padding-top: 45px;
  cursor: pointer;
}
.telPop .el-dialog__headerbtn  .el-icon-close {
  width: 20px !important;
  height: 20px !important;
  background: #0c6dce !important;
  color: #fff !important;
  border-radius: 50% !important;
  line-height: 20px !important;
}
.telPop-div {
  width: 700px;
  margin: 2px auto;
  /*border: 1px solid #333333;*/
}
.telPop-title{
  text-align: left;
  font-size: 20px;
  color: #363636;
  font-weight: bold;
  margin-bottom: 10px;
}
.redact-div {
  width: 610px;
  margin: 2px auto;
}
.redact-centre {
  padding-top: 29px;
}
.redact-centre .el-form-item__label{
  width: 160px !important;
  height: 16px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.redact-centre .el-input__inner {
  width: 380px;
  height: 39px;
  background-color: #f5f6f7;
  border-radius: 5px;
  border: solid 1px #d9d9d9;
}
.redact-title {
  width: 160px;
  height: 24px;
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 6px;
  letter-spacing: 0px;
  color: #333333;
}
.redact-dialog .el-dialog {
  width: 666px;
}
.redact-dialog hr {
  width: 595px;
  margin: 10px 0;
  border: solid 1px #cccccc;
 }
.redact-dialog .el-dialog__headerbtn  .el-icon-close {
  width: 20px !important;
  height: 20px !important;
  background: #0c6dce !important;
  color: #fff !important;
  border-radius: 50% !important;
  line-height: 20px !important;
}
.redact-dialog .el-upload--picture-card{
  width: 93px !important;
  height: 93px !important;
  background-color: #eff0f1;
}
.redact-dialog .uploadImg .el-upload-list {
  margin-right: 20px;
  position: absolute;
  z-index: 999;
}
.redact-dialog .el-upload-list__item-thumbnail,
.redact-dialog .el-upload-list--picture-card .el-upload-list__item{
  width: 93px !important;
  height: 93px !important;
}
.redact-dialog .deleteResume {
  width: 93px;
  height: 93px;
  position: absolute;
  left: 300px;
  border-radius: 5px;
  background: url("../../../assets/img/21.png") no-repeat;
  text-align: center;
  padding-top: 0px;
}
.redact-dialog .el-textarea__inner{
  background-color: #f5f6f7;
  color: #4d4d4d;
  width: 380px;
}
.redact-dialog .el-form-item__error {
  margin-left: 60px;
}
.redact-centre .el-form .btn .el-form-item__content {
  margin-left: 0 !important;
  text-align: center;
}
.linkman {
  display: flex;
  width: 700px;
  border: none;
  background: #e8f0fd;
  border-radius: 5px;
  margin-bottom: 20px;
}
.linkman-right {
  text-align: left;
  padding-top: 10px;
}
.linkman-left {
  margin: 20px 20px;
}
.linkman-mes {
  padding-top: 10px;
  color: #464849;
}
.audit {
  width: 975px;
  height: 18px;
  background-color: rgba(255, 0, 0, 0.2);
  color: #ff0000;
  font-size: 18px;
  margin: 20px 0 5px;
  padding: 16px 0 16px 15px;
  position: relative;
  left: -50px;
  top: -30px;
}

.uploadResume .el-upload-list--picture-card .el-upload-list__item{
  width: 120px;
  height: 120px;
}
.uploadResume .el-upload--picture-card{
  width: 120px;
  height: 120px;
}
.head-portrait .el-upload-list--picture-card .el-upload-list__item{
  width: 68px;
  height: 68px;
}
.head-portrait .el-upload--picture-card{
  width: 68px;
  height: 68px;
}
.head-portrait .el-upload-list--picture-card .el-upload-list__item-thumbnail{
  border-radius: 50%
}
.head-portrait .el-upload-list--picture-card .el-upload-list__item{
  border: 1px solid #ffffff;
}
.head-portrait .el-upload--picture-card i{
  top: 0px!important;
}
.head-portrait .uploadImg{
  margin-left: 0px;
  width: auto;
}
</style>
